import "core-js/modules/es.array.push.js";
// import store from '@/store/index.js'
import request from "@/util/request";
export default {
  name: "LCHearder",
  data() {
    const AreaData = [];
    return {
      userName: sessionStorage.getItem("userName"),
      dialogVisible: false,
      editform: {},
      passWord: '',
      dialogVisible1: false,
      currentPage: 1,
      pageSize: 10,
      total: 10,
      selectvalue: '',
      //个人信息修改工具箱下拉框
      toolBoxSelectUpdate: '',
      //个人信息修改安全帽下拉框
      capsSelectUpdate: '',
      //工具箱
      toolBox: [],
      //管理区域
      casvalue: [],
      AreaData: JSON.parse(JSON.stringify(AreaData)),
      setKesLabel: {
        value: 'areaId',
        label: 'areaName',
        children: 'children',
        multiple: true
      },
      modalKey: 0,
      url: ''
      // currentPathName:this.$store.getters.getCurrentPathName,
      // path:"/"+this.$store.getters.getCurrentPathName,
    };
  },

  computed: {
    currentPathName: function () {
      return this.$store.getters.getCurrentPathName;
    }
  },
  methods: {
    exit() {
      sessionStorage.removeItem("userName");
      this.$router.push({
        path: 'login',
        query: {}
      });
    },
    updatepwd() {
      this.dialogVisible = true;
      this.passWord = '';
    },
    showmessage() {
      this.imageUrl = '';
      this.casvalue = [];
      this.areaArray = [];
      this.query();
      this.dialogVisible1 = true;
      request.get('/area/useruselist').then(res => {
        this.AreaData = res.data.structList;
      });
      this.getToolBox();
      // this.getCaps();
      // if (this.treeData.roleId == 1)
    },

    cancel() {
      this.dialogVisible = false;
    },
    cancel1() {
      this.dialogVisible1 = false;
    },
    //个人信息修改弹窗确认按钮
    editSubmit(formName) {
      //工具箱下拉框
      this.editform.toolId = this.toolBoxSelectUpdate;
      // this.editform.roleId = this.selectvalue
      this.editform.roleId = this.selectvalue2;
      //安全帽下拉框
      this.editform.capIndex = this.capsSelectUpdate;
      this.editform.createBy = sessionStorage.getItem('userName');
      this.editform.updateBy = sessionStorage.getItem('userName');
      if (this.areaArray.length === 0) {
        // this.editform.areaId = "," + this.areaArray + ","
      } else {
        this.editform.areaId = "," + this.areaArray + ",";
        console.log("创建者:" + sessionStorage.getItem('userName'));
        this.editform.createBy = sessionStorage.getItem('userName');
        this.editform.updateBy = sessionStorage.getItem('userName');
      }
      console.log(this.roleArray);
      console.log(this.roleKey);
      this.$refs[formName].validate(valid => {
        // this.repeatName = this.editform.userName
        if (valid) {
          // request.post("/user/update", this.editform).then(res => {
          //   if (res.code === '0') {
          //     this.tablee = res.data
          //     this.dialogVisible = false
          //     this.query()
          //     this.$message({
          //       type: 'success',
          //       message: '修改成功!'
          //     });
          //   } else {
          //     this.$message({
          //       type: 'info',
          //       message: '区域修改失败，有未检测的工单'
          //     });
          //   }
          // })
          let map = {
            userAlias: this.editform.userAlias,
            passWord: this.editform.passWord,
            Sign: this.editform.userSign,
            id: this.editform.userId
          };
          request.post("/user/updateSign1", map).then(res => {
            if (res === 1) {
              this.$message({
                type: 'success',
                message: '修改成功!'
              });
              this.dialogVisible1 = false;
            } else {
              this.$message({
                type: 'error',
                message: '修改失败!'
              });
            }
          });
        } else {
          console.log('error submit!!');
          this.$message({
            type: 'error',
            message: '修改数据不正确,请重新输入!'
          });
          return false;
        }
      });
    },
    query() {
      this.tablee = [];
      let userMap = {
        "page": this.currentPage,
        "size": this.pageSize,
        "userName": sessionStorage.getItem("userName"),
        "roleId": ""
      };
      request.post("/user/list", userMap).then(res => {
        console.log(res.data.lists[0].userName);
        console.log(sessionStorage.getItem("userName"));
        console.log(res.data.lists);
        console.log(typeof res.data.lists);
        this.tablee = res.data.lists;
        // this.tablee.pop(res.data.lists)
        this.total = res.data.total;
        if (res.code === '500') {
          this.dialogVisible = false;
        }
        this.editform.userName = res.data.lists[0].userName;
        this.editform.userAlias = res.data.lists[0].userAlias;
        this.editform.passWord = res.data.lists[0].passWord;
        this.editform.createDate = res.data.lists[0].createDate;
        this.editform.userlock = res.data.lists[0].userlock;
        this.editform.userId = res.data.lists[0].userId;
        this.selectvalue = res.data.lists[0].roleName;
        this.selectvalue2 = res.data.lists[0].roleId;
        this.editform.userSign = res.data.lists[0].userSign;
        this.editform.phone = res.data.lists[0].phone;
        // this.treeData.roleId = res.data.lists[0].roleId;
        // this.treeData.roleName = res.data.lists[0].roleName;
        for (let i = 0; i < res.data.lists[0].areaId.toString().split(",").length; i++) {
          this.casvalue.push(parseInt(res.data.lists[0].areaId.toString().split(",")[i]));
        }
        this.toolBoxSelectUpdate = res.data.lists[0].toolId;
        this.capsSelectUpdate = res.data.lists[0].capIndex;
        this.url = res.data.lists[0].userSign;
      });
    },
    getToolBox() {
      request.get('/order/getToolBox').then(res => {
        this.toolBox = res.data;
      });
    }
  }
};